export default {
  EDIT_CUSTOMER_PROFILE_TAGS: [
    {
      method: 'PUT',
      path: '/customer-profile/{id}/add-tags',
    },
    {
      method: 'PUT',
      path: '/customer-profile/{id}/remove-tags',
    },
  ],
};
